import type { LocalizableTextEntry } from "@masta/shared";
import type { DefinitionTranslationTarget } from "./definitionTranslationTarget";

/** A label opens its own presentation properties, including texts without a clickable label. */
export function definitionTranslationAttributes(sourceId: string | undefined, key: string, entries: LocalizableTextEntry[]): Record<string, string> {
  const boundary = { "data-definition-boundary": "" };
  if (!sourceId) return boundary;
  const separator = key.includes("/") ? "/" : ".";
  const prefix = key.slice(0, key.lastIndexOf(separator) + 1);
  const related = entries.filter((entry) => {
    if (!entry.key.startsWith(prefix)) return false;
    const property = entry.key.slice(prefix.length);
    return separator === "." || !property.includes("/") || property.startsWith("enumOptions/") || property.startsWith("items/enumOptions/");
  });
  const unique = related.filter((entry) => related.filter((other) => other.key === entry.key).length === 1);
  const sourceTexts = Object.fromEntries(unique.map((entry) => [entry.key, entry.fallback]));
  const keys = [...new Set([...(key in sourceTexts ? [key] : []), ...Object.keys(sourceTexts)])];
  if (!keys.length) return boundary;
  const target: DefinitionTranslationTarget = { sourceId, keys, sourceTexts };
  return { ...boundary, "data-definition-target": JSON.stringify(target) };
}

export function resolveDefinitionTranslationTarget(target: EventTarget | null): DefinitionTranslationTarget | undefined {
  if (!(target instanceof Element)) return;
  const label = target.closest("[data-translation-label], .v-label");
  const boundary = label?.closest<HTMLElement>("[data-definition-boundary]");
  const serialized = boundary?.dataset.definitionTarget;
  if (!serialized) return;
  return JSON.parse(serialized) as DefinitionTranslationTarget;
}
